import store from '@/state/store'

export default [
  {
    path: '',
    name: 'home',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/saas/index'),
  },
  {
    path: '/project',
    name: 'project',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/projects-grid'),
  },
  {
    path: '/project/template',
    name: 'project-template',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/select-template'),
  },
  {
    path: '/project/create-target/personal',
    name: 'create-target-personal',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/create-personal'),
  },
  {
    path: '/project/create-target/personal-new',
    name: 'create-target-personal-new',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/create-personal-new'),
  },
  {
    path: '/project/create-target/non-personal',
    name: 'create-target-non-personal',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/create-non-personal'),
  },
  {
    path: '/project/create-target/organisasi',
    name: 'create-target-organisasi',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/create-personal'),
  },
  {
    path: '/project/create-target/media',
    name: 'create-target-media',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/create-personal'),
  },
  {
    path: '/project/create-target/anonymous',
    name: 'create-target-anon',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/create-personal'),
  },
  {
    path: '/project/project-overview/:id',
    name: 'project-overview',
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/overview'),
  },
  {
    path: '/report/:id/:tt/:img',
    name: 'report',
    // props: true,
    meta: { authRequired: true },
    component: () => import('./view/dashboards/project/report'),
  },
  {
    path: '/citizen',
    name: 'citizen',
    meta: { authRequired: true },
    component: () => import('./view/citizen/citizen'),
  },
  {
    path: '/citizen/view/:id',
    name: 'citizen-view',
    meta: { authRequired: true },
    component: () => import('./view/citizen/citizen-view'),
  },
  {
    path: '/group-telegram',
    name: 'group-telegram',
    meta: { authRequired: true },
    component: () => import('./view/group/group'),
  },
  {
    path: '/group-telegram/view/:id',
    name: 'group-view',
    meta: { authRequired: true },
    component: () => import('./view/group/group-view'),
  },
  {
    path: '/member-chat/:id/:name',
    name: 'member-chat',
    meta: { authRequired: true },
    component: () => import('./view/group/member-chat'),
  },
  {
    path: '/personal-database',
    name: 'personal',
    meta: { authRequired: true },
    component: () => import('./view/personal/personal'),
  },
  {
    path: '/user-management',
    name: 'user',
    meta: { authRequired: true },
    component: () => import('./view/user/user'),
  },
  {
    path: '/profile/:nik',
    name: 'profile',
    meta: { authRequired: true },
    component: () => import('./view/personal/profile'),
  },
  {
    path: '/category',
    name: 'category',
    meta: { authRequired: true },
    component: () => import('./view/category/category'),
  },
  {
    path: '/cctv',
    name: 'cctv',
    meta: { authRequired: true },
    component: () => import('./view/cctv/cctv'),
  },
  {
    path: '/cctv/detail/:id',
    name: 'detail-cctv',
    meta: { authRequired: true },
    component: () => import('./view/cctv/detail-cctv'),
  },
  {
    path: '/visual-surveillance',
    name: 'visual-surveillance',
    meta: { authRequired: true },
    component: () => import('./view/surveillance/visual-surveillance'),
  },
  {
    path: '/profile-user',
    name: 'profile-user',
    meta: { authRequired: true },
    component: () => import('./view/user/profile-user'),
  },
  {
    path: '/change-password',
    name: 'change-password',
    meta: { authRequired: true },
    component: () => import('./view/user/change-password'),
  },
  {
    path: '/twitter',
    name: 'twitter',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/twitter'),
  },
  {
    path: '/twitter-trend',
    name: 'twitter-trend',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/twitter-trend'),
  },
  {
    path: '/twitter/report-twitter/:id',
    name: 'report-twitter',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/report-twitter'),
  },
  {
    path: '/twitter/report-view/:id',
    name: 'report-view',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/report-view'),
  },
  {
    path: '/instagram',
    name: 'instagram',
    meta: { authRequired: true },
    component: () => import('./view/tools/instagram/instagram'),
  },
  {
    path: '/instagram/search',
    name: 'instagram-search',
    meta: { authRequired: true },
    component: () => import('./view/tools/instagram/instagram-search'),
  },
  {
    path: '/report-instagram/:id',
    name: 'report-instagram',
    meta: { authRequired: true },
    component: () => import('./view/tools/instagram/report-instagram'),
  },
  {
    path: '/facebook',
    name: 'facebook',
    meta: { authRequired: true },
    component: () => import('./view/tools/facebook/facebook'),
  },
  {
    path: '/tiktok',
    name: 'tiktok',
    meta: { authRequired: true },
    component: () => import('./view/tools/tiktok/index'),
  },
  {
    path: '/tiktok/search',
    name: 'tiktok-search',
    meta: { authRequired: true },
    component: () => import('./view/tools/tiktok/tiktok-search'),
  },
  {
    path: '/tiktok/:id',
    name: 'tiktok-view',
    meta: { authRequired: true },
    component: () => import('./view/tools/tiktok/tiktok-view'),
  },
  {
    path: '/youtube',
    name: 'youtube',
    meta: { authRequired: true },
    component: () => import('./view/tools/youtube/index'),
  },
  {
    path: '/phone-number',
    name: 'phone-number',
    meta: { authRequired: true },
    component: () => import('./view/tools/phone/phone-number'),
  },
  {
    path: '/advanced-search',
    name: 'advanced-search',
    meta: { authRequired: true },
    component: () => import('./view/advanced/search'),
  },
  {
    path: '/potential-breach',
    name: 'potential-breach',
    meta: { authRequired: true },
    component: () => import('./view/advanced/potential-breach'),
  },
  {
    path: '/potential-breach/detail-credential/:email',
    name: 'detail-credential',
    meta: { authRequired: true },
    component: () => import('./view/advanced/detail-potential-breach'),
  },
  {
    path: '/phone-tags',
    name: 'phone-tags',
    meta: { authRequired: true },
    component: () => import('./view/tools/phone/phone-tags'),
  },
  {
    path: '/phone-search',
    name: 'phone-search',
    meta: { authRequired: true },
    component: () => import('./view/tools/phone/phone-search'),
  },
  {
    path: '/instagram/:id',
    name: 'instagram-view',
    meta: { authRequired: true },
    component: () => import('./view/tools/instagram/instagram-view'),
  },
  {
    path: '/instagram-compare',
    name: 'instagram-compare-search',
    meta: { authRequired: true },
    component: () => import('./view/tools/instagram/instagram-compare'),
  },
  {
    path: '/twitter-compare',
    name: 'twitter-compare-search',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/twitter-compare'),
  },
  {
    path: '/twitter/twitter-search',
    name: 'twitter-search',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/twitter-search'),
  },
  {
    path: '/twitter/:id',
    name: 'twitter-view',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/twitter-view'),
  },
  {
    path: '/twitter-compare',
    name: 'twitter-compare-search',
    meta: { authRequired: true },
    component: () => import('./view/tools/twitter/twitter-compare'),
  },
  {
    path: '/website-info',
    name: 'website-info',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-info'),
  },
  {
    path: '/website-info/detail/:id',
    name: 'website-info-detail',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-info-detail'),
  },
  {
    path: '/domain-whois/detail/:id',
    name: 'website-whois-detail',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-whois-detail'),
  },
  {
    path: '/find-website',
    name: 'find-website',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-location'),
  },
  {
    path: '/news',
    name: 'news',
    meta: { authRequired: true },
    component: () => import('./view/tools/news/news'),
  },
  {
    path: '/news/news-analys',
    name: 'news-analys',
    meta: { authRequired: true },
    component: () => import('./view/tools/news/news-analys'),
  },
  {
    path: '/nlp',
    name: 'nlp',
    meta: { authRequired: true },
    component: () => import('./view/tools/news/nlp'),
  },
  {
    path: '/ocr',
    name: 'ocr',
    meta: { authRequired: true },
    component: () => import('./view/tools/ocr/ocr'),
  },
  {
    path: '/news/news-target',
    name: 'news-target',
    meta: { authRequired: true },
    component: () => import('./view/tools/news/news-target'),
  },
  {
    path: '/news/news-target/detail/:id',
    name: 'news-target-detail',
    meta: { authRequired: true },
    component: () => import('./view/tools/news/news-target-detail'),
  },
  {
    path: '/find-website/detail/:id',
    name: 'find-website-detail',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-location-detail'),
  },
  {
    path: '/domain-whois',
    name: 'domain-whois',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-whois'),
  },
  {
    path: '/subdomain-checker',
    name: 'subdomain-checker',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-subdomain'),
  },
  {
    path: '/subdomain-checker/detail/:id',
    name: 'subdomain-checker-detail',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-subdomain-detail'),
  },
  {
    path: '/cms-checker',
    name: 'cms-checker',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-cms-checker'),
  },
  {
    path: '/cms-checker/detail/:id',
    name: 'cms-checker-detail',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-cms-detail'),
  },
  {
    path: '/web-service',
    name: 'web-service',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-web-service'),
  },
  {
    path: '/web-service/detail/:id',
    name: 'web-service-detail',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-web-service-detail'),
  },
  {
    path: '/age-checker',
    name: 'age-checker',
    meta: { authRequired: true },
    component: () => import('./view/tools/website/website-age-checker'),
  },
  {
    path: '/education-search',
    name: 'education-search',
    meta: { authRequired: true },
    component: () => import('./view/education/index'),
  },
  {
    path: '/career-search',
    name: 'career-search',
    meta: { authRequired: true },
    component: () => import('./view/education/career'),
  },
  {
    path: '/career-search/detail/:id',
    name: 'detail-career',
    meta: { authRequired: true },
    component: () => import('./view/education/detail-career'),
  },
  {
    path: '/education-search/detail-mahasiswa/:id',
    name: 'detail-mahasiswa',
    meta: { authRequired: true },
    component: () => import('./view/education/detail-mahasiswa'),
  },

  {
    path: '/preferences',
    name: 'preferences',
    meta: { authRequired: true },
    component: () => import('./view/preferences/preferences'),
  },

  {
    path: '/pref-news',
    name: 'pref-news',
    meta: { authRequired: true },
    component: () => import('./view/news/setting'),
  },

  {
    path: '/galaxy',
    name: 'galaxy',
    meta: { authRequired: true },
    component: () => import('./view/galaxy/index'),
  },

  {
    path: '/galaxy-search/:id',
    name: 'galaxy-search',
    meta: { authRequired: true },
    component: () => import('./view/galaxy/index-search'),
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('./view/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.state.authBackend.status.loggeduser) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('./view/account/register'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/forgot-password',
    name: 'Forgot password',
    component: () => import('./view/account/forgot-password'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'home' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authBackend/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
]
